module.exports = __webpack_public_path__ + "static/media/eTransfer.8be6446c.png";